import { releaseDraftLockAction } from "@/app/lib/actions/cat/draft-lock-heartbeat";
import { resetVehicleAssignmentStores } from "@/lib/cat/reset-vehicle-assignment-stores";
import type { Kvps } from "@/lib/kvps";
import { useCurrentDraftStore } from "@/stores/selected-vehicle-store";

const VEHICLE_ASSIGNMENT_WORKFLOW_PATHS = [
  "/backoffice/cat/vehicle-assignment/retail",
  "/backoffice/cat/vehicle-assignment/avs",
] as const;

export function isVehicleAssignmentWorkflowPath(pathname: string): boolean {
  return VEHICLE_ASSIGNMENT_WORKFLOW_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

type HandleKvpsContextChangeParams = {
  pathname: string;
  nextKvps: Kvps;
  update: (data: { kvps: { current: Kvps } }) => Promise<unknown>;
};

/**
 * Updates the KVPS session context. When the user is in the CTM workflow,
 * clears local flow state and navigates to step 1 (no query). Draft DB data
 * is left untouched. Outside the workflow, reloads the current page.
 */
export async function handleKvpsContextChange({
  pathname,
  nextKvps,
  update,
}: HandleKvpsContextChangeParams): Promise<void> {
  await update({ kvps: { current: nextKvps } });

  if (!isVehicleAssignmentWorkflowPath(pathname)) {
    window.location.reload();
    return;
  }

  const draftId = useCurrentDraftStore.getState().currentDraft?.id;
  if (draftId) {
    await releaseDraftLockAction({ draftId });
  }

  resetVehicleAssignmentStores();

  // Strip step / draftId so the flow restarts at vehicle identification.
  window.location.assign(pathname);
}
